<div class="relative m-0">
  <button (click)="popoverLogin.toggle($event)"
    class="flex flex-col md:flex-row gap-1 xl:gap-2 items-center justify-center p-0 md:p-2 md:px-2 text-gray-700 hover:text-allasRed transition-colors h-full w-full">
    <!-- User icon placeholder -->
    @if (!showCurrentUser) {
    <img src="/allas-icons/signin.svg" alt="Usuario" class="w-auto h-4 xl:h-6" />
    <span class="text-xs xl:text-sm font-light fs-condensed" [class.hidden]="isInStickyHeader">
      Mi Cuenta
    </span>
    } @else {
    <img src="/allas-icons/signin.svg" alt="Usuario" class="w-auto h-4" [ngClass]="{ 'xl:h-6': !isInStickyHeader }" />
    <span class="text-xs xl:text-sm font-light fs-condensed" [class.hidden]="isInStickyHeader">
      Hola, {{ getUserDisplayName().split(' ')[0] || 'Usuario' }}
    </span>
    }
    <lucide-icon class="hidden md:inline" [name]="chevronDownIcon"></lucide-icon>
  </button>
</div>

<p-popover #popoverLogin appendTo="body" styleClass="p-0">
  <ng-template pTemplate="content" class="p-0">
    <div class="fs-condensed w-80 transition-all duration-300 ease-in-out">
      <!---->
      @if (!currentUser) {
      <!-- Login section para usuarios no autenticados -->
      <div class="p-2 pb-4 text-md text-gray-900 fs-condensed">
        <button (click)="onLoginClick()"
          class="tracking-wide w-full bg-gray-900 text-white px-4 py-2 rounded-3xl font-medium hover:bg-gray-800 transition-colors">
          Iniciar sesión o crear una cuenta
        </button>
      </div>
      <hr class="border-gray-200" />
      } @else {
      <!-- Sección para usuarios autenticados -->
      <div class="p-4 bg-gray-900 text-white rounded-t-lg">
        <div class="text-center">
          <div class="text-lg font-semibold mb-1">Bienvenido a ALLAS</div>
          <div class="text-sm text-gray-300">
            {{ currentUser.nombrePreferido }}
          </div>
        </div>
      </div>
      }

      <!---->
      @if (!currentUser) {

      <!-- Menu items para usuarios no autenticados -->
      <div class="py-2">
        @for(item of menuItems; track item.title) {
        <button (click)="onMenuItemClick(item)"
          class="w-full px-4 py-3 text-left hover:bg-gray-50 flex items-start space-x-3">
          <div class="text-gray-600 mt-0.5">
            @if(item.icon === 'log-in') {
            <img src="/images/login/shop-icon.webp" alt="Encuentre un taller referido" class="w-4 h-4" />
            } @else if(item.icon === 'gift') {
            <img src="/images/login/allas-icon.webp" alt="Gane recompensas" class="w-4 h-4" />
            } @else if(item.icon === 'gift') {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7">
              </path>
            </svg>
            } @else if(item.icon === 'package') {
            <img src="/images/login/box-icon.webp" alt="Seguimiento de pedidos" class="w-4 h-4" />
            }
          </div>
          <div class="flex-1">
            <div class="font-normal text-gray-900 fs-condensed">
              {{ item.title }}
            </div>
            <div class="text-xs text-gray-600 mt-1 fs-condensed">
              {{ item.description }}
            </div>
          </div>
        </button>
        }
      </div>
      } @else {
      <!-- Opción de cerrar sesión para usuarios autenticados -->
      <div class="py-2">
        <button (click)="logout()" class="w-full px-4 py-3 text-left hover:bg-gray-50 flex items-start space-x-3">
          <div class="text-gray-600 mt-0.5">
            <i class="pi pi-sign-out text-lg"></i>
          </div>
          <div class="flex-1">
            <div class="font-medium text-gray-900">Cerrar sesión</div>
            <div class="text-sm text-gray-600 mt-1">Salir de tu cuenta</div>
          </div>
        </button>
      </div>
      }
    </div>
  </ng-template>
</p-popover>